module.exports = __webpack_public_path__ + "img/game5.3.4aa40d79.png";